
import React from "react";
import { FiArrowRight } from "react-icons/fi";

import VapesImage from "../../assets/img/Vapes.png";
import ELiquidsImage from "../../assets/img/ELiquidsImage.png";
import CannabisImage2 from "../../assets/img/CannabisImage (2).png";
import LingerieImage from "../../assets/img/LingerieImage (2).png";
import WellnessImage from "../../assets/img/WellnessImage (2).png";
import AccessoriesImage from "../../assets/img/AccessoriesImage.png";
import AdultToysImage from "../../assets/img/AdultToysImage.png";
import GiftIdeasImage from "../../assets/img/GiftIdeasImage.png";

const categoryItems = [
  {
    title: "Vapes & Devices",
    image: VapesImage,
    href: "/vapes-devices",
  },
  {
    title: "E-Liquids",
    image: ELiquidsImage,
    href: "/e-liquids",
  },
  {
    title: "Cannabis & Hemp",
    image: CannabisImage2,
    href: "/cannabis-hemp",
  },
  {
    title: "Lingerie",
    image: LingerieImage,
    href: "/lingerie",
  },
  {
    title: "Wellness",
    image: WellnessImage,
    href: "/wellness",
  },
  {
    title: "Accessories",
    image: AccessoriesImage,
    href: "/accessories",
  },
  {
    title: "Adult Toys",
    image: AdultToysImage,
    href: "/adult-toys",
  },
  {
    title: "Gift Ideas",
    image: GiftIdeasImage,
    href: "/gift-ideas",
  },
];

export default function ShopByCategory() {
  return (
    <section className="w-full bg-[#fffdfb] px-4 py-3 sm:px-6 lg:px-[4.3%]">
      <div className="mx-auto w-full max-w-[1400px]">
        {/* Section heading */}
        <div className="mb-[9px] flex items-center justify-between">
          <h2 className="flex items-center gap-[9px] font-serif text-[20px] font-bold leading-none tracking-[-0.5px] text-[#17151b] sm:text-[22px]">
            <span className="h-[14px] w-[2px] rounded-full bg-[#7027df]" />
            Shop by Category
          </h2>

          <a
            href="/shop"
            className="flex shrink-0 items-center gap-[5px] text-[9px] font-semibold text-[#6b28d9] transition-colors hover:text-[#4818a8] sm:text-[10px]"
          >
            View All Categories
            <FiArrowRight size={12} />
          </a>
        </div>

        {/* Category image grid */}
        <div className="grid grid-cols-4 gap-x-[8px] gap-y-4 md:grid-cols-8">
          {categoryItems.map((category) => (
            <a
              key={category.title}
              href={category.href}
              className="group min-w-0 text-center"
            >
              <div className="aspect-[1.04/1] w-full overflow-hidden rounded-[7px] bg-[#f0eaf0]">
                <img
                  src={category.image}
                  alt={category.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.04]"
                />
              </div>

              <p className="mt-[5px] truncate text-[9px] font-bold leading-[13px] text-[#24212a]">
                {category.title}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
